var _filter, _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLd = function SvgLd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "LD_svg__Layer_2",
    "data-name": "Layer 2",
    viewBox: "0 0 22.63 22.63"
  }), /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "LD_svg__luminosity-invert",
    width: 28,
    height: 28,
    x: -3,
    y: -2.55,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "cm",
    values: "-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".LD_svg__cls-1{fill:#fff}")), /*#__PURE__*/React.createElement("mask", {
    id: "LD_svg__mask",
    width: 28,
    height: 28,
    x: -3,
    y: -2.55,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAACXBIWXMAAAsSAAALEgHS3X78AAABHklEQVRIie2WwW2EMBBFP0uORlQCTVEANyrghHAJFuVQABd3gYW5gT172IACCwpJDJGS/ZIlazz6T7bH8ngACBfqdiUMAN7WAc45oigCYwy+7wMAPM/71IjocVDWWiil0DQNsizbzp1GVVXUdR25kNaahBD00f99PCacc2ewSUopKstyAZzvMIoiBEFw/DIOKAxDxHG8iM1AxphT2J7vDJwKxLXWvpc/ixl4pPS/o7Xv7+3wBXwB/y+QaPm/3/YWTgeeJWPMNtBaewqw7/ttoFLKOWwcR0gpn+IEgIqiIK210x+/ruv9FgMACSFIKfVj0DAMVNc15Xn+BFx0bUmSoG1bxHH8pa6NiEBEMMag73tIKZGm6Wauh7/eCF8OvANtvKm7Mj01WgAAAABJRU5ErkJggg==",
    width: 28,
    height: 28,
    style: {
      filter: "url(#LD_svg__luminosity-invert)"
    },
    transform: "translate(-3 -2.55)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LD_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.63,
    height: 22.63,
    rx: 5.37,
    ry: 5.37,
    style: {
      fill: "#8c9499"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#LD_svg__mask)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.63,
    height: 22.63,
    rx: 5.37,
    ry: 5.37,
    style: {
      opacity: 0.5
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.68 14.85V7.77h1.34v5.83h3.05v1.25H5.69ZM11.15 14.85V7.77h2.63c.17 0 .34.01.5.03.57.07 1.05.27 1.45.59.4.33.7.74.9 1.25.21.5.31 1.06.31 1.66s-.1 1.15-.31 1.66c-.21.5-.51.92-.9 1.25-.4.33-.88.53-1.45.59-.16.02-.33.03-.5.03h-2.63Zm1.35-1.26h1.29c.15 0 .29-.02.41-.04.31-.06.56-.21.75-.43s.34-.5.43-.82a3.63 3.63 0 0 0 0-1.99c-.1-.32-.24-.59-.44-.81s-.44-.36-.74-.42c-.12-.03-.26-.04-.41-.04H12.5v4.56Z",
    className: "LD_svg__cls-1"
  }))));
};
export default SvgLd;